<template>
  <div>
    <gc-order-detail-with-actions :show-place-holder="emkt.leaveSpaceForFullScreen" :show-product-contract-no="false">
      <template #addressOperation="{orderDetail}">
        <router-link
          :to="{
                name: 'WeappAddress',
                params: { order: orderDetail, addressType: 1 },
              }"
        >
          <div class="update-address update-address-color">修改</div>
        </router-link>
      </template>
      <template #productOperations="{item, orderDetail}">
        <div
          class="pay-btn research-background-color"
          v-if="showAmplificationBtn(item, orderDetail) && item.name !== '实物返还'"
          @click="amplifyProduct(item, orderDetail)"
        >
          我要扩增
        </div>
        <div
          class="pay-btn research-background-color"
          v-if="showBuyAgainBtn(item, orderDetail)"
          @click="buyProductAgain(item, orderDetail)">
          再次购买
        </div>
      </template>
      <template #orderOperations="{orderDetail}">
        <div
          v-if="showCancelButton(orderDetail)"
          class="cancel-btn research-font-color"
          @click="handleOrderCancel(orderDetail)"
        >
          取消订单
        </div>
        <div
          class="cancel-btn research-font-color"
          @click="toPayInvoice(orderDetail)"
          v-if="showInvoiceBtn(orderDetail)"
        >
          查看发票
        </div>
        <div
          class="submit-btn research-background-color"
          @click="toSendContract(orderDetail)"
          v-if="showContractBtn(orderDetail)"
        >
          下载合同
        </div>
        <div
          class="research-background-color"
          :class="orderDetail.fromEmkt ? 'submit-btn': 'sf-sampleGuid-btn'"
          @click="toSampleDeliveryList(orderMaterialInfo)"
          v-if="showSampleDeliveryGuideBtn(orderDetail)"
        >
          寄送实物
        </div>
        <div
          v-if="showSubmitOrderButton(orderDetail)"
          class="submit-btn research-background-color"
          @click="handleOrderSubmit(orderDetail)"
        >
          提交订单
        </div>
        <div
          v-if="showSubmitToCheckSignApproveButton(orderDetail)"
          class="submit-btn research-background-color"
          @click="handleOrderToCheckSignApprove(orderDetail)"
        >
          重新提交
        </div>
        <div
          v-if="showSignSubmitOrderButton(orderDetail)"
          class="submit-btn research-background-color"
          @click="handleOrderToSign(orderDetail)"
        >
          签署合同
        </div>
      </template>
    </gc-order-detail-with-actions>
  </div>

</template>

<script>
/* eslint-disable */

// import $ from 'jquery'
import Clipboard from 'clipboard'
import { mapGetters, mapMutations, mapState } from 'vuex'
import EMKT from '@/emkt.js'
import wx from 'wx'
import GcOrderDetailWithActions from '../../../emktcommon/orders/order/GcOrderDetailWithActions.vue'

export default {
  data () {
    return {
      status: 2,
      orderList: {},
      baseurl: '/emktResources/resocurces/img/merchandise/',
      serviceUrl: '/emktResources/resocurces/img/merchandise/service.png',
      routeType: 1,
      fileName: '',
      fileSize: '',
      orderMaterialInfo: [],
      showProgress: true,
      SCProgressInfo: null
    }
  },
  created () {
  },
  components: { GcOrderDetailWithActions },
  computed: {
    ...mapGetters(['chosenOrder', 'hasLogin', 'researchGroupCharacter', 'customerNo']),
    ...mapState(['cartList', 'weappMyOrders']),
  },
  methods: {
    ...mapMutations([
      'ADD_CART_LIST',
      'SET_CURRENT_WAITPAY_ORDER',
      'ORDER_MATERIAL_INFO'
    ]),
    toSendContract (orderDetail) {
      EMKT.wxDownloadOrderText(orderDetail)
    },
    toSampleDeliveryList: function (orderMaterialInfo) {
      this.ORDER_MATERIAL_INFO(orderMaterialInfo)
      this.$router.push({
        name: 'SampleDeliveryList'
      })
    },
    stringSet (str) {
      if (str) {
        let temp = str.replace(/&nbsp;/gi, ' ')
        return temp
      } else {
        return ''
      }
    },
    showContractBtn (orderDetail) {
      return EMKT.showDownloadOrderTextBtn(orderDetail)
    },
    showSampleDeliveryGuideBtn (orderDetail) {
      if (!orderDetail || !orderDetail.orderNo) return false
      this.gcapi('loadOrderMaterialInfo', orderDetail.orderNo).then((res) => {
        if (res.body.result === '[]') return false
        else {
          this.orderMaterialInfo = JSON.parse(res.body.result)
          let statusText = this.getOrderStatusText(orderDetail)
          return (statusText === '已完成' || statusText === '执行中')
        }
      })
    },
    showInvoiceBtn (orderDetail) {
      if (!orderDetail) return false
      if (!orderDetail.fromEmkt) return false
      return (
        orderDetail.payType !== EMKT.PAY_TYPE_REMAIN_MONEY &&
        orderDetail.status >= EMKT.ORDER_STATUS_PAIED
      )
    },
    copy () {
      const clipboard = new Clipboard('#tag-copy')
      // 或者不绑定 const clipboard = new Clipboard("#tag-copy", () => '复制的内容')
      clipboard.on('success', (e) => {
        this.$weui.toast('复制成功', 1500)
        // $.toast('复制成功')
        clipboard.destroy() // 释放内存
      })
      clipboard.on('error', (e) => {
        this.$weui.topTips('该浏览器不支持自动复制')
        // $.toast('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    // goMessage () {
    //   window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
    // },
    getStatusStyle: EMKT.getStatusStyle,
    getOrderStatusText: EMKT.getOrderStatusText,
    showCancelButton (order) {
      console.log('showCancelButton', order)
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以取消订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      let statusText = this.getOrderStatusText(order)
      return (
        statusText === '待提交' ||
        statusText === '待审批' ||
        statusText === '执行中' ||
        statusText === '待签署' ||
        statusText === '技术审核中' ||
        statusText === '待重新提交'
      )
    },
    showSubmitToCheckSignApproveButton (order) {
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      let statusText = this.getOrderStatusText(order)
      return statusText === '待重新提交'
    },
    showSubmitOrderButton (order) {
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      let statusText = this.getOrderStatusText(order)
      return statusText === '待提交'
    },
    showSignSubmitOrderButton (order) {
      if (!order) return false
      if (!order.fromEmkt) {
        return false
      }
      // 仅下单人可以操作订单
      if (order.customerNo !== this.customerNo) {
        return false
      }
      let statusText = this.getOrderStatusText(order)
      return statusText === '待签署'
    },
    handleOrderToSign (order) {
      this.$router.push({ name: 'promotions', query: { orderId: order.id, cc: true } })
    },
    showAmplificationBtn (item, orderDetail) {
      if (!item) return false
      if (!orderDetail.fromEmkt) return false
      // 仅下单人可以操作订单
      if (orderDetail.customerNo !== this.customerNo) {
        return false
      }
      return (
        orderDetail.status === EMKT.ORDER_STATUS_FINISHED &&
        item.categoryId === 20
      )
    },
    showBuyAgainBtn (item, orderDetail) {
      if (!item || item.orderType !== 1) return false
      if (!orderDetail.fromEmkt) return false
      // 仅下单人可以操作订单
      if (orderDetail.customerNo !== this.customerNo) {
        return false
      }
      // return true
      return (
        orderDetail.status === EMKT.ORDER_STATUS_ABORT ||
        (orderDetail.status === EMKT.ORDER_STATUS_FINISHED &&
          item.categoryId !== 20) || orderDetail.status === EMKT.ORDER_STATUS_CHECK_BAD || orderDetail.status === EMKT.ORDER_STATUS_WAIT_PD_TECH_AUDIT_FAIL
      )
    },
    buyCustomizeProductAgain (order, ifAmplify) {
      if (ifAmplify === true) {
        order.merchandises[0].amplification = 1
        order.merchandises[0].merchandiseDetailForClient.amplification = 1
      }
      if (
        typeof order.merchandises[0].merchandiseDetailForClient._attributes
          .TVInfo.value === 'string'
      ) {
        let obj = {}
        obj.TLNo =
          order.merchandises[0].merchandiseDetailForClient._attributes.TVInfo.value
        if (
          order.merchandises[0].merchandiseDetailForClient._attributesList[0]
            .columnName === 'TVInfo'
        ) {
          order.merchandises[0].merchandiseDetailForClient._attributesList[0].value =
            obj
          order.merchandises[0].merchandiseDetailForClient._attributesList[0].valueText =
            obj
        }
      }
      for (let i in order.merchandises[0].merchandiseDetailForClient
        ._attributesList) {
        if (
          order.merchandises[0].merchandiseDetailForClient._attributesList[i]
            .value !== '214' &&
          (order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'AAVBloodType' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'VirusTiter' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'LVAmount' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'NC_LV_Amount' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'NC_LV_Amount' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'NC_Lentivirus_Required' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'NC_Plasmid_Amount' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'NC_Plasmid_CultureRequired' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'NC_Plasmid_Required' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'PlasmidNumber' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'Plasmid_Required' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'Plasmid_Amount' ||
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName === 'Plasmid_CultureRequired')
        ) {
        } else {
          if (
            (order.merchandises[0].merchandiseDetailForClient._attributesList[i]
                .groupId === 2 ||
              order.merchandises[0].merchandiseDetailForClient._attributesList[
                i
                ].groupId === 3) &&
            order.merchandises[0].merchandiseDetailForClient._attributesList[i]
              .columnName !== 'GeneInfo'
          ) {
            order.merchandises[0].merchandiseDetailForClient._attributesList[
              i
              ].displayable = 0
          }
          order.merchandises[0].merchandiseDetailForClient._attributesList[
            i
            ].sorteditAble = false
        }
        if (
          order.merchandises[0].merchandiseDetailForClient._attributesList[i]
            .columnName === 'ContractType'
        ) {
          order.merchandises[0].merchandiseDetailForClient._attributesList[
            i
            ].value = 3
          order.merchandises[0].merchandiseDetailForClient._attributes.ContractType.value = 3
          order.merchandises[0].merchandiseDetailForClient._attributesList[
            i
            ].valueText = 3
        }
        if (
          order.merchandises[0].merchandiseDetailForClient._attributesList[i]
            .columnName === 'Type' ||
          order.merchandises[0].merchandiseDetailForClient._attributesList[i]
            .columnName === 'Tech'
        ) {
          order.merchandises[0].merchandiseDetailForClient._attributes.Type.value =
            '-1'
          order.merchandises[0].merchandiseDetailForClient._attributes.Tech.value =
            '-1'
          order.merchandises[0].merchandiseDetailForClient._attributesList[
            i
            ].value = '-1'
          order.merchandises[0].merchandiseDetailForClient._attributesList[
            i
            ].valueText = '-1'
        }
        if (
          order.merchandises[0].merchandiseDetailForClient._attributesList[i]
            .columnName === 'Source'
        ) {
          order.merchandises[0].merchandiseDetailForClient._attributes.Source.value = 3
          order.merchandises[0].merchandiseDetailForClient._attributesList[
            i
            ].value = 3
          order.merchandises[0].merchandiseDetailForClient._attributesList[
            i
            ].valueText = 3
        }
        if (
          order.merchandises[0].merchandiseDetailForClient._attributesList[i]
            .columnName === 'PlasmidNumber'
        ) {
          if (
            order.merchandises[0].merchandiseDetailForClient._attributes
              .ToolType.value === '2' ||
            order.merchandises[0].merchandiseDetailForClient._attributes
              .ToolType.value === 2
          ) {
            order.merchandises[0].merchandiseDetailForClient._attributesList[
              i
              ].value =
              order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.value
            order.merchandises[0].merchandiseDetailForClient._attributesList[
              i
              ].valueText =
              order.merchandises[0].merchandiseDetailForClient._attributes.TargetNum.valueText
          }
        }
        if (
          order.merchandises[0].merchandiseDetailForClient._attributesList[i]
            .columnName === 'VirusTiter'
        ) {
          if (
            order.merchandises[0].merchandiseDetailForClient._attributes
              .ProductName.value === 'RNAi综合－腺相关病毒外筛'
          ) {
            order.merchandises[0].merchandiseDetailForClient._attributesList[
              i
              ].value = 3
            order.merchandises[0].merchandiseDetailForClient._attributesList[
              i
              ].valueText = 3
          }
        }
      }
      this.$router.push({
        name: 'finderMerchandises',
        query: {
          categoryId:
          order.merchandises[0].merchandiseDetailForClient.categoryId,
        },
        params: {
          merchandises: order.merchandises[0].merchandiseDetailForClient,
        },
      })
    },
    amplifyProduct (item, orderDetail) {
      if (!item) return
      if (item.orderId) {
        this.gcapi('assambleOrders', item.orderId).then((res) => {
          console.log('我要扩增', res.body.result)
          let order = res.body.result
          this.buyCustomizeProductAgain(order, true)
        })
      }
    },
    buyProductAgain (item, orderDetail) {
      if (item.orderId) {
        if (item.categoryId === 6) {
          self.$weui.topTips('细胞相关产品已经下架！不可再次购买！', 2000)
          return
        }
        if (item.categoryId === 20) {
          this.$router.push({ name: 'finder' })
          return
        }
        this.$weui.loading('正在获取商品数据')
        // $.showPreloader('正在获取商品数据')
        this.gcapi('assambleOrders', item.orderId).then((res) => {
          // $.hidePreloader()
          this.$weui.loading().hide()
          console.log('再次购买', res.body.result)
          // let order = res.body.result
          const merchandise = res.body.result.merchandises.find(
            (mer) =>
              mer.categoryId !== 20 &&
              mer.merchandiseGuid === item.merchandiseGuid &&
              mer.presentQuantity === 0
          )
          const merchandiseDetail =
            merchandise && merchandise.merchandiseDetailForClient
          // if (merchandise.categoryId === 20) {
          //   merchandiseDetail.productGuid = order.productGuid
          //   this.buyCustomizeProductAgain(order, false)
          //   console.log('再次购买定制商品')
          //   return
          // }
          this.ADD_CART_LIST(merchandiseDetail)
          console.log('ADD_CART_LIST', this.cartList, merchandiseDetail)
          this.checkFromWeapp()
        })
      }
    },
    checkFromWeapp () {
      if (EMKT.isWapp) {
        // 手动保存到数据库
        this.saveCartManually()
      } else {
        this.$router.push({ name: 'cart' })
      }
    },
    saveCartManually () {
      const cartJsonString = JSON.stringify(this.cartList.cartContent)
      this.$weui.loading('正在添加到购物车')
      // $.showPreloader('正在添加到购物车')
      this.gcapi('saveShoppingCart', cartJsonString).then((response) => {
        // $.hidePreloader()
        this.$weui.loading().hide()
        if (response.body.code === 0) {
          console.log(
            '再次购买：save Shopping cart successfully, 即将跳转购物车'
          )
          if (EMKT.isWapp) {
            wx.miniProgram.switchTab({
              url: '/pages/cart/cart',
            })
          }
        } else {
          this.$weui.topTips('保存失败', 1000)
        }
      })
    },
    cancelOrder (order) {
      if (!order) return
      let orderId = order.id
      if (!orderId) {
        return this.$weui.topTips('当前订单缺少订单编号')
        // return $.toast('当前订单缺少订单编号')
      }
      if (
        order.status > EMKT.ORDER_STATUS_PAIED &&
        order.status < EMKT.ORDER_STATUS_FINISHED
      ) {
        return alert('订单已开始生产，无法自行取消，如有疑问请联系客服人员', {
          buttons: [
            {
              label: '我知道了',
            },
          ],
        })
      }
      this.$weui.loading('正在取消订单')
      // $.showPreloader('正在取消订单')
      this.gcapi('orderCancel', { id: orderId }).then((data) => {
        // $.hidePreloader()
        this.$weui.loading().hide()
        EMKT.setStoreItem('cancelledOrder', order)
        this.$weui.toast('取消成功', 1500)
        // $.toast('取消成功')
        // 返回到orders页面更新weappMyOrders
        this.$router.go(-1)
      })
    },
    handleOrderCancel (order) {
      this.$weui.dialog({
        title: '当订单未提交或未开始生产时，您随时可以取消订单，是否确认取消？',
        buttons: [
          {
            label: '否',
            type: 'default',
            onClick: () => {
              return
            },
          },
          {
            label: '是',
            type: 'primary',
            onClick: () => {
              this.cancelOrder(order)
            },
          },
        ],
      })
    },
    handleOrderSubmit (order) {
      this.gcapi('getWaitPayOrderInfoByOrderId', order.id).then((res) => {
        if (res && res.body.result) {
          const waitPayOrder = res.body.result
          this.SET_CURRENT_WAITPAY_ORDER(waitPayOrder)
          this.$router.replace({ name: 'WeappOrderConfirmation' })
        }
      })
    },
    handleOrderToCheckSignApprove (bOrder) {
      this.$weui.loading('加载中')
      this.gcapi('checkOrderSignAndApprove', [{ id: bOrder.id }]).then(response => {
        if (response && response.body.result && response.body.code === 0) {
          this.$weui.loading('加载中').hide()
          let order = response.body.result[0]
          if (order.status === EMKT.ORDER_STATUS_ABORT) {
            alert('该订单享受的优惠已失效，此订单已自动取消，请您重新下单')
            if (EMKT.isWapp) {
              wx.miniProgram.switchTab({ url: '/pages/cart/cart' })
            } else {
              this.$router.replace({ name: 'cart' })
            }
          } else if (order.status === EMKT.ORDER_STATUS_CHECK || order.status === EMKT.ORDER_STATUS_WAIT_PD_TECH_AUDIT || order.status === EMKT.ORDER_STATUS_SUBMITTED) {
            this.$router.replace({ name: 'submitSuccess', query: { info: true, orderStatus: order.status } })
          } else if (order.status === EMKT.ORDER_STATUS_SIGN_NEED) {
            this.$router.replace({ name: 'promotions', query: { orderId: order.id, cc: true } })
          } else if (order.status === EMKT.ORDER_STATUS_PAIED) {
            this.$router.replace({ name: 'WeappSuccessPay', params: { orderId: order.id } })
          } else if (order.status === EMKT.ORDER_STATUS_WAIT_CHECK_SIGN_APPROVE) {
            this.$weui.topTips('提交订单失败，请联系客服或重新提交订单')
          }
        }
      })
    },
    toPayInvoice (orderDetail) {
      this.$router.push({
        name: 'updateInvoiceTitle',
        params: { order: orderDetail },
      })
    },
  },
}
</script>

<style scoped>

.update-address {
  width: 42px;
  height: 23px;
  line-height: 21px;
  text-align: center;
  border-radius: 44px;
  border: 1px solid #5878fa;
}

.update-address-color {
  font-size: 12px;
  color: #5878fa;
}


row {
  position: relative;
  margin-top: 2.4vw;
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(239, 238, 243, 1);
  width: 94.67vw;
  height: 0.27vw;
}

.sf-sampleGuid-btn {
  width: 73px;
  height: 23px;
  border-radius: 44px;
  line-height: 23px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  /*position: absolute;*/
  /*right: 10px;*/
}
</style>



// WEBPACK FOOTER //
// OrderDetailPage.vue?02ec4368